import React, {useState} from 'react'
import {IconButton, Divider, Typography, Grid} from '@material-ui/core'
import '../../styles/Reservation/Reservation.scss'
import SearchItem from './SearchItem'
import SelectedItems from './SelectedItems'
import ItemFirst from './ItemFirst'
import DateFirst from './DateFirst/DateFirst'
import CloseIcon from '@material-ui/icons/Close'
import {ReservationProvider} from '../../context/Reservation/Reservation'

const ReservationReserve = ({fromGantt, onClose, handleReserve}) => {
  const [reservationType, setReservationType] = useState('date_first')

  const [groupObjectIds, setGroupObjectIds] = React.useState([])

  const handleClickCancel = e => {
    window.parent.postMessage('close-popup', document.referrer)
  }

  const handleClickSave = e => {
    window.parent.postMessage('close-popup', document.referrer)
    window.open(document.referrer, '_top')
  }

  const handleClose = e => {
    onClose(e)
  }

  React.useEffect(() => {
    window.addEventListener('message', receiveMessage, false)

    function receiveMessage(e) {
      const {event, payload} = e.data || {}
      switch (event) {
        case 'group_object_ids':
          setGroupObjectIds(payload)
          break
        default:
          console.log('Unexpected message event: ', event)
          break
      }
    }

    return () => {
      window.removeEventListener('message', receiveMessage)
    }
  }, [setGroupObjectIds])

  return (
    <>
      {reservationType === 'item_first' && (
        <ItemFirst onClose={onClose} handleReserve={handleReserve} />
      )}
      {reservationType === 'date_first' && (
        <DateFirst fromGantt={fromGantt} onClose={onClose} handleReserve={handleReserve} />
      )}
    </>
  )
}

export default ReservationReserve
